import React from "react";
import type { PriceTier } from "../types/megapack";
import { E } from "./Emoji";
type DiscountBadgeProps = {
  tier: PriceTier;
};
export function DiscountBadge({
  tier
}: DiscountBadgeProps) {
  if (!tier.referenceValue) return null;
  const pct = Math.round((1 - tier.value / tier.referenceValue) * 100);
  return <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-red px-2 py-0.5 text-[11px] font-black uppercase text-white" data-id="element-27" data-mp="1b685zpjocdvf">
      <E data-id="element-28" data-mp="1k7piyz1sbzfw">{`⏰ −${pct}% · Tiempo limitado`}</E>
    </span>;
}